module.exports = __webpack_public_path__ + "static/media/2000-GG-Wagon.f82de4ef.webp";